import * as S from "./styles.ts";
import { UniversalLink } from "@template/components";
import ChevronRight from "@template/icons/ChevronRight.tsx";
import ReviewsIoWidget from "@template/blocks/CustomerReviewsSection/component/CtaOverlay/reviews-io-widget.tsx";
import GoogleWidget from "@template/blocks/CustomerReviewsSection/component/CtaOverlay/google-widget.tsx";
import Image from "next/image";
import TrustPilot from "@/lib/images/about/Trustpilot-logo.svg";

interface ICtaOverlayProps {
  cta?: { text?: string; href?: string };
  showFooter?: boolean;
  hideOverlay?: boolean;
}

export const CtaOverlay = ({
  cta,
  showFooter = true,
  hideOverlay,
}: ICtaOverlayProps) => {
  return (
    <S.Overlay $hideOverlay={hideOverlay}>
      <S.Content>
        {cta?.text && (
          <UniversalLink href={cta.href}>
            <S.CtaLink>
              {cta.text}
              <ChevronRight />
            </S.CtaLink>
          </UniversalLink>
        )}
        {showFooter && (
          <S.ReviewImages>
            <div>
              <UniversalLink
                rel="nofollow"
                href="https://uk.trustpilot.com/review/yay.com"
                target="_blank"
              >
                <Image
                  src={TrustPilot}
                  alt={"TrustPilot"}
                  height={80}
                  width={135}
                  style={{
                    objectFit: "contain",
                  }}
                />
              </UniversalLink>
              {/* <TrustPilotWidget /> */}
            </div>
            <ReviewsIoWidget />
            <GoogleWidget />
            {/*{averageRatingsImages.map((image, index) => (*/}
            {/*    <UniversalLink*/}
            {/*        href={image.href}*/}
            {/*        target="_about"*/}
            {/*        key={index}*/}
            {/*    >*/}
            {/*        <Image*/}
            {/*            key={index}*/}
            {/*            src={image.src}*/}
            {/*            alt={image.alt}*/}
            {/*            height={100}*/}
            {/*            width={200}*/}
            {/*            style={{*/}
            {/*                objectFit: 'contain'*/}
            {/*            }}*/}
            {/*        />*/}
            {/*    </UniversalLink>*/}
            {/*))}*/}
          </S.ReviewImages>
        )}
      </S.Content>
    </S.Overlay>
  );
};
